import React from "react";
import TwoFactorMFAForm from "./TwoFactorMFAForm";

interface IProps {
    displayData?: any;
    registrationState?: any;
    setRegistrationState?: any;
    manage?: any;
    reCompleteRegistrationState?: any;
    setReCompleteRegistrationState?: any;
}

const TwoFactorMFA = ({ reCompleteRegistrationState, setReCompleteRegistrationState }: IProps) => {
    return (
        <div className="row" id="content">
            <div className="col-xs">
                <div className="box box-has-shadow offset-padding">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon" aria-hidden="true">
                                <em className="la la-lock"></em>
                            </div>
                            <div className="box-title-text">
                                <h2 className="box-title">Two Factor Authentication</h2>
                            </div>
                        </div>
                    </div>
                    <TwoFactorMFAForm
                        reCompleteRegistrationState={reCompleteRegistrationState}
                        setReCompleteRegistrationState={setReCompleteRegistrationState}
                    ></TwoFactorMFAForm>
                </div>
            </div>
        </div>
    );
};

export default TwoFactorMFA;
